import { Component, Input } from '@angular/core';
import {
  WarningArrayItemDeletionComponent,
} from '../../../../warning-array-item-deletion/warning-array-item-deletion.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventManager } from '../../../../../../core/managers/event.manager';
import { CalculationEventEnum } from '../../../../../../core/enums/calculation-event.enum';
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {
  SalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/salary-dividend.options';
import {
  IncomeTaxPersonalChildOptions,
} from '../../../../../../../../../../../common/src/options/calculations/income-tax/personal/personal/income-tax-personal-child.options';
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {
  IncomeTaxPersonalInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/personal/income-tax-personal-in-salary-dividend.options';
import {
    IncomeTaxPersonalChildInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/personal/income-tax-personal-child-in-salary-dividend.options';


@Component({
  selector: 'app-salary-dividend-personal-tax-children-form',
  templateUrl: './salary-dividend-personal-tax-children-form.component.html',
  styleUrls: ['./salary-dividend-personal-tax-children-form.component.scss'],
  standalone: false,
})
export class SalaryDividendPersonalTaxChildrenFormComponent {

  @Input()
  children: AdvancedFormArray<IncomeTaxPersonalChildInSalaryDividendOptions>;
  @Input()
  form: AdvancedForm<SalaryDividendOptions>;

  constructor(public modalService: NgbModal, private readonly eventManager: EventManager) {

  }

  get incomeTaxPersonalForm(): AdvancedFormGroup<IncomeTaxPersonalInSalaryDividendOptions> {
    return this.form.formElements.incomeTaxPersonalOptions as AdvancedFormGroup<IncomeTaxPersonalInSalaryDividendOptions>;
  }

  async removeChild(childIndexToRemove: number) {
    const modal = this.modalService.open(WarningArrayItemDeletionComponent, {});
    (modal.componentInstance as WarningArrayItemDeletionComponent).objectDefinition = 'cet enfant';
    modal.closed.subscribe(async result => {
      if (result === true) {
        // Here we delete only in the form, not syncing the change to the server or else deleting could cause bad data to be sync.
        this.children.delete(childIndexToRemove);
        // Re-validate so the error list no longer references the removed child's index.
        this.eventManager.publishEvent(CalculationEventEnum.FormArrayItemDeleted);

        return;
      }
    });

    return;
  }

  addChild() {
    this.children.appendNew();
  }

}
